import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Form, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faTabletAlt, faGlobeAsia, faUserCircle, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { updateUser, viewUser, addUserRole, removeUserRole } from "../Network/User"
import { useHistory, useParams } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { listCompany } from '../Network/Company'
import { listDepartment, addUserToDepartment, removeFromDepartment } from '../Network/Department'
import { listRole } from '../Network/Role'
import MultiSelect from "react-multi-select-component";
import "./VisitorDetail.css"
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from "../Role/RoleContext"
import axios from 'axios'
import { wtc5214,visitor8082 } from '../Network/Config'

function EditSecurity(props) {

    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.user
    const notifyCx = useContext(NotifyContext);
    const history = useHistory();
    const { securityId } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState("Loading");

    const [securityVisitor, setSecurityVisitor] = useState([])
    const [securityName, setSecurityName] = useState("");
    const [isError, setError] = useState(false);


    const [role, setRole] = useState([])

    useEffect( async () => {
            console.log(props)
            /*setLoadingTitle(lang.loading_data)
            setLoading(true)*/
                if(props.company !== undefined){
                    const formData = new FormData();
                    formData.append('company_name', props.company);
                    await axios.post(visitor8082+'/visitor/api/v1/security_list', formData).then(function (responseData) {
                        responseData.data.map((item, key)=>{
                            if(item.security_id == securityId){
                                setSecurityName(item.security_name);
                            }
                        })
                    }).catch(function (error) {
                        console.log(error);
                    });
                }

    }, [1000, props])


    const onSubmit = () =>{
        if( !securityName ){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }
        setLoadingTitle(lang.updating)
        setLoading(true);
        addSecurity(securityName);

    }
    
    const addSecurity = async (name) =>{
        console.log(securityId);
        console.log(name);
        const formDataUpdate = new FormData();
        formDataUpdate.append('security_id', securityId);
        formDataUpdate.append('company_name', props.company);
        formDataUpdate.append('security_name', name);
        const responseData = await axios.post(visitor8082+'/visitor/api/v1/security_update', formDataUpdate);
        setLoading(false)
        history.push("/visitor_security")
    }

    return (
        <>
        { isLoading ? <Loading title={loadingTitle}/>: null }
        <div id="create-user">
            <HeaderTitle title={'แก้ไขชื่อรปภ.'} isShowBack backTo="/visitor_security"/>
            <Row style={{width: "100%"}}>
                <Col className="content-container" md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        onSubmit();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{'ชื่อรปภ.'}</Form.Label>
                            <Form.Control
                            placeholder="ชื่อรปภ."
                            value={securityName}
                            isInvalid={isError && !securityName}
                            onChange={(e)=>setSecurityName(e.target.value)}
                            />
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Button type="submit" style={{marginTop: 30}}>{lang.save_change}</Button>
                        </Form.Group>
                        
                    </Form>
                </Col>
            </Row>
        </div>
        </>
    )
}


export default EditSecurity
